import type { ExcelGridBodyProps } from "../models/excel-grid-component-props.models";
import { ExcelGridRowCells } from "./ExcelGridRowCells";

export const ExcelGridBody = ({
  rows,
  columns,
  rowHeight,
  dataTest,
  editing,
  selection,
  selectedCellRef,
  onCancelEditing,
  onCommitEditing,
  onCommitEditingValue,
  onEditValueChange,
  onFocusGrid,
  onStartEditing,
  onSelectionChange,
  isSavingCell,
  cellEditorMode,
  selectMenuPortalTarget,
}: ExcelGridBodyProps) => (
  <tbody>
    {rows.map((row, rowIndex) => (
      <tr key={row.gridRowId} data-test={`${dataTest}-row-${row.gridRowId}`} className="excel-grid-row align-top">
        <ExcelGridRowCells
          row={row}
          rowIndex={rowIndex}
          columns={columns}
          rowHeight={rowHeight}
          dataTest={dataTest}
          editing={editing}
          selection={selection}
          selectedCellRef={selectedCellRef}
          onCancelEditing={onCancelEditing}
          onCommitEditing={onCommitEditing}
          onCommitEditingValue={onCommitEditingValue}
          onEditValueChange={onEditValueChange}
          onFocusGrid={onFocusGrid}
          onStartEditing={onStartEditing}
          onSelectionChange={onSelectionChange}
          isSavingCell={isSavingCell}
          cellEditorMode={cellEditorMode}
          selectMenuPortalTarget={selectMenuPortalTarget}
        />
      </tr>
    ))}
  </tbody>
);
